<div class="captioned-media-gallery" *ngIf="config.media | isMeMedia">
    <!-- Generic Text component or Header component -->
    <ng-content></ng-content>
    <finder-media-gallery
        [config]="config"
        [theme]="theme">
    </finder-media-gallery>
    <finder-generic-text *ngIf="mediaCaption | hasText"
        class="captions"
        [data]="mediaCaption"
    ></finder-generic-text>
</div>
